import Layout from 'layouts/Default'
import {
  StyledBoxContainerContent as ContainerContent,
  StyledBoxContainerTitle as ContainerTitle,
} from './styles'
import { Box, Button, Grid, Pagination, Stack, Tooltip, Typography } from '@mui/material'
import Label from 'components/Label'
import React, { Fragment, useEffect, useState } from 'react'
import { PendingProcessHearingType } from 'types/pending-process-hearing.type'
import { useNavigate } from 'react-router-dom'
import { usePendingProcessHearing } from 'pages/PendingProcessHearing/hook/pending-process-hearing.hook'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown'
import { ModalPromotoria } from 'components/ModalPromotoria'
import { usePromotoriaContext } from 'contexts/promotoria.context'
import { useBackdrop } from 'contexts/backdrop.context'
import { AdolescentesAgendadosModal } from 'pages/PendingProcessHearing/modal/AdolescentesAgendadosModal'
import { CardProcessHearing } from 'pages/PendingProcessHearing/component/CardProcessHearing'
import { PendingProcessHearingForm } from 'pages/PendingProcessHearing/form/PendingProcessHearingForm'

export const getStatusBackgroundColor = (value: string) => {
  return PENDING_PROCESS_HEARING_COLORS.status[value]
}

export const getCategoryBorderColor = (value: string) => {
  return PENDING_PROCESS_HEARING_COLORS.category[value]
}

const PENDING_PROCESS_HEARING_COLORS: any = {
  category: {
    AIAI: '#0371af',
    AAAPAI: '#31b603',
    BOC: '#ce7308',
  },
  status: {
    PENDENTE: '#d0b89b',
    AGENDADO: '#6996af',
    NAO_REALIZADO: '#d1d0cf',
    FINALIZADO: '#6da656',
  },
}

const PendingProcessHearing = () => {
  const {
    promotoriaSelecionada,
    promotorias,
    handleOpenModalPromotoria,
    openModalPromotoria,
    handleCloseModalPromotoria,
  } = usePromotoriaContext()

  const {
    processos,
    totalProcesso,
    loaded,

    handleBuscarTodos,

    page,
    rowsPerPage,
    rowsOptions,
    totalOfPages,
    totalOfElements,
    handleNewPage,
    handleRowsPerPage,

    resetProcessos,
  } = usePendingProcessHearing()

  const navigate = useNavigate()

  const [somatoriaItens, setSomatoriaItens] = useState<number>(0)

  useEffect(() => {
    if (processos) {
      setSomatoriaItens(page * rowsPerPage + processos.length || 0)
    }
  }, [page, processos, rowsPerPage])

  /*useEffect(() => {
    if (promotoriaSelecionada && !loaded) {
      handleBackdropOpen()
    } else {
      handleBackdropClose()
    }
  }, [loaded])*/

  const handleNavigate = (data: PendingProcessHearingType) => {
    navigate(`/processos-pendentes/${data.id}`, {
      state: {
        promotoria: promotoriaSelecionada?.id,
      },
    })
  }

  return (
    <Layout>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ContainerTitle>
            <Label text='PROCESSOS PENDENTES DE OITIVA' v='h6' bold />
          </ContainerTitle>
          <ContainerContent>
            <Box display={'flex'} gap={4} alignItems={'center'} flexWrap={'wrap'}>
              <Box display={'flex'} gap={1}>
                <Label text='Processos Pendentes de Oitivas' v='body1' />
                <Label text={`(${totalProcesso})`} v='body1' color={'red'} />
              </Box>
              {promotoriaSelecionada && (
                <Tooltip title={'Selecione o órgão.'}>
                  <Button
                    startIcon={<ExpandCircleDownIcon fontSize={'large'} />}
                    variant={'text'}
                    color={'secondary'}
                    disabled={promotorias.length <= 1}
                    onClick={() => handleOpenModalPromotoria()}
                  >
                    <b>{promotoriaSelecionada?.descricao}</b>
                  </Button>
                </Tooltip>
              )}
            </Box>
            <AdolescentesAgendadosModal />
          </ContainerContent>
        </Grid>
        <Grid item xs={12}>
          <PendingProcessHearingForm
            onBuscarCallback={handleBuscarTodos}
            promotoriaSelecionada={promotoriaSelecionada}
            resetData={resetProcessos}
          />
        </Grid>
        <Grid container item spacing={4}>
          {loaded &&
            (processos && processos.length > 0 ? (
              <>
                {processos.map((i) => (
                  <Grid item lg={3} xs={12} key={i.id}>
                    <CardProcessHearing data={i} onNavigate={handleNavigate} />
                  </Grid>
                ))}
                <Grid item xs={12}>
                  <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                    <Typography variant={'body2'}>
                      Mostrando {somatoriaItens} de {totalOfElements || 0}
                    </Typography>
                    <Pagination
                      count={totalOfPages}
                      page={page + 1}
                      variant='outlined'
                      shape='rounded'
                      onChange={handleNewPage}
                    />
                    <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                      <Typography variant={'body2'} sx={{ marginRight: '0.25rem' }}>
                        Itens por página:
                      </Typography>
                      <FormControl sx={{ m: 1, minWidth: 120 }} size='small'>
                        <Select
                          labelId='demo-select-small-label'
                          variant={'outlined'}
                          id='demo-select-small'
                          value={rowsPerPage}
                          onChange={(e: any) => handleRowsPerPage(e)}
                        >
                          {rowsOptions.map((item, index) => (
                            <MenuItem key={index} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </Box>
                </Grid>
              </>
            ) : (
              <Grid item xs={12}>
                <Stack direction='row' justifyContent='center' spacing={2}>
                  <Label text='Nenhum resultado encontrado...' bold />
                </Stack>
              </Grid>
            ))}
        </Grid>
      </Grid>
      <ModalPromotoria
        open={openModalPromotoria}
        onClose={handleCloseModalPromotoria}
        promotorias={promotorias}
      />
    </Layout>
  )
}

export default PendingProcessHearing
